import script from "./Articles.vue?vue&type=script&setup=true&lang=js"
export * from "./Articles.vue?vue&type=script&setup=true&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=f2fb82ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2fb82ca"]])

export default __exports__